import { Box, Flex } from "@chakra-ui/react";
import { ArrowLeft, ArrowRight } from "lucide-react";

/*
  A circular pagination arrow button for kiosk page navigation.
  Hides itself when disabled (no ghost circles).
*/
export default function PaginationArrow({ direction, disabled, onClick }) {
  const Icon = direction === "left" ? ArrowLeft : ArrowRight;

  return (
    <Flex align="center" flexShrink={0} w="80px" justify="center">
      {!disabled && (
        <Box
          as="button"
          aria-label={direction === "left" ? "Previous page" : "Next page"}
          display="flex"
          alignItems="center"
          justifyContent="center"
          bgGradient="linear(to-r, #EC2227, #F15B27)"
          color="white"
          boxShadow="md"
          boxSize="76px"
          rounded="full"
          cursor="pointer"
          onClick={onClick}
          transition="box-shadow 0.15s"
          sx={{
            "@media (hover: hover)": {
              "&:hover": {
                boxShadow: "lg",
              },
            },
          }}
          _active={{ boxShadow: "inset 0 0 0 999px rgb(0 0 0 / 12%)" }}
        >
          <Box as={Icon} boxSize={7} aria-hidden="true" />
        </Box>
      )}
    </Flex>
  );
}
